<template>
  <div class="col-12">
    <div class="card card-body" v-if="user">
      <h5>رابط الاستعلام لأولياء الأمور</h5>
      <p class="text-muted" style="margin-bottom: 8px;">
        شارك هذا الرابط مع أولياء الأمور للاستعلام عن لجان أبنائهم. يتم البحث في اللجان المحددة بالأسفل. يمكنك تحديد أكثر من لجنة، وإذا كان الطالب في عدة لجان سيتم عرضها جميعاً.
      </p>
      <div class="input-group">
        <input type="text" class="form-control" :value="findUrl" id="findUrlInput" readonly>
        <div class="input-group-append">
          <button class="btn btn-success" @click="copyLink()">
            <i class="fa fa-copy"></i> نسخ الرابط
          </button>
          <a :href="findUrl" target="_blank" class="btn btn-info">
            <i class="fa fa-external-link"></i> فتح
          </a>
        </div>
      </div>
    </div>
    <div class="card card-body">
      <div class="col-12 table-responsive">
        <h4 v-if="loading">جاري التحميل...</h4>
        <table class="table table-hover table-bordered">
          <thead>
            <th>التاريخ</th>
            <th>النوع</th>
            <th>تفعيل للاستعلام</th>
            <th>عرض</th>
          </thead>
          <tbody>
            <tr v-for="a in arr" :key="a._id">
              <td>
                {{ a.date }}
              </td>
              <td>
                {{
                  a.type
                    .replace("1", "كل فصل في لجنة")
                    .replace("2", "توزيع تسلسلي (توزيع كل صف في عامود)")
                    .replace("3", "توزيع ديناميكي")
                }}
              </td>
              <td class="text-center">
                <div class="form-check" style="display: inline-block;">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :id="'main_' + a._id"
                    :checked="a.is_main"
                    @change="toggleMain(a)"
                    style="width: 20px; height: 20px; cursor: pointer;"
                  >
                  <label :for="'main_' + a._id" style="cursor: pointer; margin-right: 6px;">
                    تفعيل للاستعلام
                  </label>
                </div>
              </td>
              <td class="text-right">
                <button
                  class="btn btn-block btn-relief-success"
                  @click="$router.push('/_committees/create#' + a._id)"
                >
                  <i class="fa fa-eye"></i>
                  عرض
                </button>
                &nbsp;
                <button
                  class="btn btn-sm text-danger"
                  title="حذف العملية"
                  @click="deleteThis(a._id)"
                >
                  <i class="fa fa-trash"></i> حذف العملية
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>

var user = JSON.parse(localStorage.getItem("user"))
export default {
  data() {
    return {
      loading: true,
      arr: [],
      user: user
    };
  },
  computed: {
    findUrl(){
      return window.location.origin + '/find-comm/' + this.user._id;
    }
  },
  created() {
    if(!checkPer("committees")){
        this.$router.push('/NotPermitted')
        return false;
    }
    this.loadHistory();
  },
  methods: {
    loadHistory(){
      var g = this;
      g.loading = true;
      $.post(api + "/user/committees/history", {
        jwt: user.jwt,
      })
        .then(function (a) {
          g.arr = a.response;
          g.loading = false;
        })
        .catch(function (a) {
          alert("حدث خطأ");
          g.loading = false;
        });
    },
    toggleMain(a){
      var newVal = !a.is_main;
      $.post(api + "/user/committees/set-main", {
        jwt: user.jwt,
        id: a._id,
        value: newVal
      }).then(function(){
        a.is_main = newVal;
      }).fail(function(){
        alert("حدث خطأ", 200);
      })
    },
    copyLink(){
      var input = document.getElementById('findUrlInput');
      input.select();
      input.setSelectionRange(0, 99999);
      try{
        document.execCommand('copy');
        alert("تم نسخ الرابط", 100);
      }catch(e){}
    },
    deleteThis(id) {
      if (confirm("متأكد من حذف هذه العملية نهائياً؟")) {
        var g = this;
        g.loading = true;
        $.post(api + "/user/committees/delete", {
          jwt: user.jwt,
          id: id,
        })
          .then(function (a) {
            location.reload();
          })
          .catch(function (a) {
            alert("حدث خطأ");
            g.loading = false;
          });
      }
    },
  },
};
</script>

<style>
</style>
